var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8795 3.56875C15.5889 3.27823 15.1558 3.27823 14.8652 3.56875L8.72078 9.71322C7.84952 10.5845 7.84916 11.5833 8.71996 12.455L14.8903 18.7304C15.1808 19.021 15.614 19.021 15.9045 18.7304C16.195 18.4399 16.195 17.9067 15.9045 17.6162L9.83246 11.5442C9.54194 11.2536 9.54194 10.7205 9.83246 10.43L15.8795 4.38297C16.17 4.09244 16.17 3.65928 15.8795 3.56875Z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHover);
export default __webpack_public_path__ + "static/media/arrowHover.53c0f7a9964f6042bfb541b92dc4832d.svg";
export { ForwardRef as ReactComponent };